// Mise's public social pages and marketing inbox. One list, used by the footer and the Contact page.

export const MARKETING_EMAIL = "marketing@misekitchen.ca";

// Mise Kitchen on LinkedIn. If this is ever emptied,
// LinkedIn is left out everywhere.
const LINKEDIN_URL = "https://www.linkedin.com/company/mise-kitchen/";

export const SOCIAL_LINKS = [
  { key: "instagram", label: "Instagram", handle: "@mise__kitchen", href: "https://www.instagram.com/mise__kitchen/" },
  { key: "tiktok", label: "TikTok", handle: "@mise_kitchen", href: "https://www.tiktok.com/@mise_kitchen" },
  { key: "facebook", label: "Facebook", handle: "Mise", href: "https://www.facebook.com/profile.php?id=61595640044784" },
  { key: "linkedin", label: "LinkedIn", handle: "Mise Kitchen", href: LINKEDIN_URL },
].filter((s) => s.href);
